import React from 'react';

const Logo = ({ size = 'md', showText = true, className = '', textColor = '#FF6600' }) => {
  const sizes = {
    sm: { height: 'h-8', text: 'text-lg' },
    md: { height: 'h-10', text: 'text-2xl' },
    lg: { height: 'h-12', text: 'text-3xl' }
  };

  const currentSize = sizes[size] || sizes.md;

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <img 
        src="/specard-logo.png" 
        alt="Specard Logo" 
        className={`${currentSize.height} object-contain`}
      />
      {showText && (
        <span 
          className={`${currentSize.text} font-bold`}
          style={{ color: textColor }}
        >
          Specard
        </span>
      )}
    </div>
  );
};

export default Logo;
